WiseMetering.Views.ShowInfraspeakConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/infraspeak/show',
    title: () => i18next.t('modal.title.integration_configurations.show'),

    // edit: function() {
    //     new WiseMetering.Views.EditInfraspeakConfiguration({ model: this.model });
    // },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site()
        };
    }
});
